import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=61d61a58&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"
import style0 from "./Landing.vue?vue&type=style&index=0&id=61d61a58&prod&scoped=true&lang=css"
import style1 from "./Landing.vue?vue&type=style&index=1&id=61d61a58&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d61a58",
  null
  
)

export default component.exports